"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bootstrapTenantSchema = void 0;
const zod_1 = require("zod");
// Mirrors core/authentication/password.service.ts's policy regex — see
// user.schema.ts's identical duplication note for why.
const PASSWORD_POLICY_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;
exports.bootstrapTenantSchema = zod_1.z.object({
    tenantCode: zod_1.z
        .string()
        .min(2)
        .max(20)
        .regex(/^[A-Z0-9]+$/, 'Tenant code must be uppercase alphanumeric'),
    tenantName: zod_1.z.string().min(1).max(255),
    hospitalLegalName: zod_1.z.string().min(1).max(255),
    hospitalDisplayName: zod_1.z.string().min(1).max(255),
    adminEmail: zod_1.z.string().email(),
    adminPassword: zod_1.z.string().regex(PASSWORD_POLICY_REGEX, 'Password does not meet the complexity policy'),
    adminFirstName: zod_1.z.string().min(1).max(100),
    adminLastName: zod_1.z.string().min(1).max(100),
});
//# sourceMappingURL=bootstrap.schema.js.map